<div class="col-lg-12 content-scroll-screen parent">
  <p-card>
    <div class="d-flex justify-content-between align-items-center gap-3 mb-3">
      <div class="d-flex align-items-center gap-3">
        <h2 class="mb-0">Access approvals</h2>
        @if (loading()) {
          <jni-spinner></jni-spinner>
        }
      </div>
      <p-button
        label="Refresh"
        icon="pi pi-refresh"
        [disabled]="loading()"
        (onClick)="refresh()" />
    </div>
    <p class="text-body-secondary">
      Held requests do not grant new access. Invitations are sent immediately on
      approval; Sent confirms dispatch.
    </p>
    @if (errorMessage()) {
      <p role="alert" class="text-danger">{{ errorMessage() }}</p>
    }
    <p-table
      #dt
      [value]="accessApprovals()"
      [lazy]="true"
      (onLazyLoad)="loadData($event)"
      [totalRecords]="totalRecords()"
      [filters]="tableFilters()"
      [paginator]="true"
      [rows]="25"
      [rowsPerPageOptions]="[10, 25, 50]"
      [filterDelay]="400"
      [stripedRows]="true"
      [rowHover]="true"
      [scrollable]="accessApprovals().length > 0"
      [scrollHeight]="
        accessApprovals().length > 0 ? 'calc(100vh - 360px)' : undefined
      "
      [styleClass]="
        accessApprovals().length > 0
          ? 'table-listing'
          : 'table-listing no-data-table'
      "
      size="small"
      dataKey="id"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} requests">
      <ng-template #header>
        <tr class="table-head text-capitalize">
          @for (column of columns; track column.field) {
            <th [pSortableColumn]="column.field">
              {{ column.label }}
              <p-sortIcon class="ms-1" [field]="column.field" />
            </th>
          }
          <th>Buyer email</th>
          <th pSortableColumn="CreatedBy">
            Created by <p-sortIcon class="ms-1" field="CreatedBy" />
          </th>
          <th pSortableColumn="CreatedDate">
            Created Date <p-sortIcon class="ms-1" field="CreatedDate" />
          </th>
          <th pSortableColumn="Status">
            Status <p-sortIcon class="ms-1" field="Status" />
          </th>
          <th>History / dispatch</th>
          <th>Action</th>
        </tr>
        <tr class="sort-row">
          @for (column of columns; track column.field) {
            <th>
              <input
                #filterInput
                pInputText
                type="text"
                class="p-column-filter"
                [attr.aria-label]="'Filter ' + column.label"
                [value]="tableFilters()[column.field]?.value ?? ''"
                [placeholder]="
                  column.matchMode === 'equals' ? 'Exact match' : 'Search'
                "
                (input)="
                  onColumnFilter(
                    column.field,
                    column.matchMode,
                    filterInput.value
                  )
                " />
            </th>
          }
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template #body let-item>
        <tr>
          <td>{{ item.customerAccount }}</td>
          <td>{{ item.clientName || "—" }}</td>
          <td>{{ item.projectId }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.buyerEmail || "—" }}</td>
          <td>{{ item.requestedBy }}</td>
          <td>{{ item.requestedAt | date: "medium" }}</td>
          <td>
            <p-tag
              [value]="item.status"
              [styleClass]="
                'rounded-pill status-tag-' + item.status.toLowerCase()
              " />
          </td>
          <td>
            @if (item.decidedAt) {
              <div>
                {{ item.decidedBy }} · {{ item.decidedAt | date: "medium" }}
              </div>
            }
            @if (item.status === "Approved") {
              <div>Awaiting delivery</div>
            }
            @if (item.sentAt) {
              <div>Sent {{ item.sentAt | date: "medium" }}</div>
            }
            @if (item.cancelledAt) {
              <div>
                Cancelled {{ item.cancelledAt | date: "medium" }} ·
                {{ item.cancelledBy }}
              </div>
            }
          </td>
          <td>
            <div class="d-flex gap-2">
              <p-button
                label="Approve"
                size="small"
                severity="success"
                styleClass="approve-btn"
                [disabled]="
                  item.status !== 'Pending' ||
                  loading() ||
                  decidingIds().has(item.id)
                "
                (onClick)="approve(item)" />
              <p-button
                label="Reject"
                size="small"
                severity="danger"
                styleClass="reject-btn"
                [disabled]="
                  item.status !== 'Pending' ||
                  loading() ||
                  decidingIds().has(item.id)
                "
                (onClick)="reject(item)" />
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage
        ><tr>
          <td colspan="10" class="no-data-cell border-0">
            @if (loading() || !hasLoaded()) {
              <div
                class="d-flex align-items-center justify-content-center text-center h-100 w-100">
                Loading requests…
              </div>
            } @else if (!errorMessage()) {
              <div
                class="d-flex align-items-center justify-content-center flex-column text-center h-100 w-100">
                <span class="no-data-image d-block w-25 h-25 mb-4"></span>
                <h3 class="fw-medium fs-5 mb-2">No Data found</h3>
              </div>
            }
          </td>
        </tr></ng-template
      >
    </p-table>
  </p-card>
</div>
